import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const logoContainerStyle = {
  margin: '.6875rem 0 0 -0.3125rem',
};

const textContainerStyle = {
  display: 'inline-block',
  marginLeft: '.375rem',
  marginRight: 0,
  color: 'rgba(0, 0, 0, .75)',
  letterSpacing: '.013125rem',
  paddingLeft: '.625rem',
  paddingRight: '.625rem',
  fontSize: '.875rem',
  lineHeight: '3rem',
  verticalAlign: 'top',
};

const GoogleButton = ({ googleLogoURL, label, t }) => {
  return (
    <div>
      <img alt="" style={logoContainerStyle} src={googleLogoURL} />
      <span style={textContainerStyle}>{t(label)}</span>
    </div>
  );
};

GoogleButton.defaultProps = {
  googleLogoURL: '/images/g.svg',
};

GoogleButton.propTypes = {
  googleLogoURL: PropTypes.string,
};

export default withTranslation()(GoogleButton);
